module.exports = __webpack_public_path__ + "img/VC.eb7e4ee3.png";